export const CHART_FILL_COLOR_1 = '#00a0fc';
export const CHART_STROKE_COLOR_1 = '#5D79A9';
export const CHART_COLUMN_COLOR_1 = '#97ACBE';
export const TEXT_DARK = '#000000';
export const CHART_RED = '#FF5450';
export const CHART_BLUE = '#005CD9';
